import {EntityType, KeyVault, KeyVaultForm} from "./Model";
import {EntityStore, startEntityStore} from "./resourceStoreBuilder";
import {create} from "zustand";
import {officeArrayResource} from "./CurrentOfficeStore";
import Subscription from "../util/Subscription";
import {KeyVaults_Read} from "../util/access/Permission";

interface KeyVaultStore extends EntityStore<KeyVault[]>{
    createKeyVault: (form: KeyVaultForm) => Promise<KeyVault>,
    updateKeyVault: (keyVault: KeyVault, form: KeyVaultForm) => Promise<KeyVault>,
    deleteKeyVault: (keyVault: KeyVault) => Promise<void>,
}

export const keyVaultSubscription = new Subscription();


export const useKeyVaultStore = create<KeyVaultStore>()(
    officeArrayResource<KeyVault, KeyVaultStore>(EntityType.KeyVaults, builder => {
        const rest = builder.crud('/key-vaults', 'id');

        return {
            remoteValue: builder.all(KeyVaults_Read, () => rest.getAll()),
            createKeyVault: builder.createAndPatch<KeyVaultForm>(rest, keyVaultSubscription),
            updateKeyVault: builder.updateAndPatch<KeyVaultForm>(rest, keyVaultSubscription),
            deleteKeyVault: builder.deleteAndPatch<KeyVaultForm>(rest, keyVaultSubscription),
        };
    })
);

startEntityStore(useKeyVaultStore);
